var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "stlBrowserWrap" },
    [
      _vm.showFilters && _vm.filterGroups.length
        ? _c("div", { staticClass: "stlBrowserFilters" }, [
            _c(
              "div",
              { ref: "filterBar", staticClass: "stlBrowserFiltersDesktop" },
              [
                _c(
                  "div",
                  { staticClass: "stlBrowserFilterGroups" },
                  _vm._l(_vm.filterGroups, function (group) {
                    return _c("shop-the-look-filter-group", {
                      key: group.type,
                      attrs: {
                        group: group,
                        "selected-tag-ids": _vm.activeTagIds,
                        "is-open": _vm.openFilterType === group.type,
                      },
                      on: {
                        toggle: _vm.toggleTag,
                        "toggle-open": _vm.toggleFilterGroup,
                      },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "stlBrowserFilterSummary" }, [
                  _vm.activeFilterChips.length
                    ? _c(
                        "div",
                        { staticClass: "stlActiveFilters" },
                        _vm._l(_vm.activeFilterChips, function (chip) {
                          return _c(
                            "button",
                            {
                              key: chip.id,
                              staticClass: "stlActiveFilterChip",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleTag(chip.id)
                                },
                              },
                            },
                            [
                              _c("span", [_vm._v(_vm._s(chip.value))]),
                              _vm._v(" "),
                              _c("span", { attrs: { "aria-hidden": "true" } }, [
                                _vm._v("×"),
                              ]),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "stlFilterReset",
                      attrs: {
                        type: "button",
                        disabled: !_vm.activeFilterCount,
                      },
                      on: { click: _vm.clearAllFilters },
                    },
                    [_vm._v("\n          Filter zurücksetzen\n        ")]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "stlBrowserFiltersMobile" }, [
              _c(
                "button",
                {
                  staticClass: "stlMobileFilterToggle",
                  attrs: { type: "button" },
                  on: { click: _vm.openMobileFilters },
                },
                [
                  _c("span", [_vm._v("Filter öffnen")]),
                  _vm._v(" "),
                  _vm.activeFilterCount
                    ? _c("span", { staticClass: "stlMobileFilterCount" }, [
                        _vm._v(_vm._s(_vm.activeFilterCount)),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _vm.activeFilterChips.length
                ? _c(
                    "div",
                    { staticClass: "stlMobileActiveFilters" },
                    _vm._l(_vm.activeFilterChips, function (chip) {
                      return _c(
                        "button",
                        {
                          key: chip.id,
                          staticClass: "stlActiveFilterChip",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleTag(chip.id)
                            },
                          },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(chip.value))]),
                          _vm._v(" "),
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×"),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.activeFilterCount
                ? _c(
                    "button",
                    {
                      staticClass: "stlFilterReset stlFilterResetMobile",
                      attrs: { type: "button" },
                      on: { click: _vm.clearAllFilters },
                    },
                    [_vm._v("\n        Filter zurücksetzen\n      ")]
                  )
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showFilters && _vm.isMobileFiltersOpen
        ? _c(
            "div",
            {
              staticClass: "stlFilterSheetBackdrop",
              on: {
                click: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.closeMobileFilters.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "stlFilterSheet" }, [
                _c("div", { staticClass: "stlFilterSheetHeader" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "stlFilterSheetClose",
                      attrs: {
                        type: "button",
                        "aria-label": "Filter schliessen",
                      },
                      on: { click: _vm.closeMobileFilters },
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×"),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stlFilterSheetMeta" }, [
                  _vm.activeFilterChips.length
                    ? _c(
                        "div",
                        {
                          staticClass: "stlActiveFilters stlActiveFiltersSheet",
                        },
                        _vm._l(_vm.activeFilterChips, function (chip) {
                          return _c(
                            "button",
                            {
                              key: chip.id,
                              staticClass: "stlActiveFilterChip",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleTag(chip.id)
                                },
                              },
                            },
                            [
                              _c("span", [_vm._v(_vm._s(chip.value))]),
                              _vm._v(" "),
                              _c("span", { attrs: { "aria-hidden": "true" } }, [
                                _vm._v("×"),
                              ]),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "stlFilterReset",
                      attrs: {
                        type: "button",
                        disabled: !_vm.activeFilterCount,
                      },
                      on: { click: _vm.clearAllFilters },
                    },
                    [_vm._v("\n          Filter zurücksetzen\n        ")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "stlFilterSheetGroups" },
                  _vm._l(_vm.filterGroups, function (group) {
                    return _c("shop-the-look-filter-group", {
                      key: `mobile-${group.type}`,
                      attrs: {
                        group: group,
                        "selected-tag-ids": _vm.activeTagIds,
                        "is-open": _vm.openFilterType === group.type,
                        "is-mobile": true,
                      },
                      on: {
                        toggle: _vm.toggleTag,
                        "toggle-open": _vm.toggleFilterGroup,
                      },
                    })
                  }),
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "grid",
          staticClass: "stlBrowserGrid",
          class: { "is-masonry-ready": _vm.isMasonryReady },
        },
        [
          _vm.isFilterLoading
            ? _c(
                "div",
                {
                  staticClass: "stlBrowserGridLoading",
                  attrs: { "aria-hidden": "true" },
                },
                [_c("div", { staticClass: "stlBrowserGridLoadingSpinner" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "stlBrowserSizer" }),
          _vm._v(" "),
          _vm._l(_vm.looks, function (look, index) {
            return _c(
              "div",
              { key: look.id, staticClass: "stlBrowserItem" },
              [
                _c("shop-the-look-stack", {
                  ref: "lookStacks",
                  refInFor: true,
                  attrs: { group: look, "auto-cycle": false },
                  on: {
                    "open-fullscreen": function ($event) {
                      return _vm.openFullscreen(index, $event)
                    },
                    "layout-needed": _vm.scheduleLayout,
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "stlBrowserError" }, [
            _vm._v("\n    " + _vm._s(_vm.error) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasMore
        ? _c("div", { staticClass: "stlBrowserActions" }, [
            _c(
              "button",
              {
                staticClass: "stlBrowserLoadMore btn btn-bkm",
                attrs: { type: "button", disabled: _vm.isLoading },
                on: { click: _vm.loadMore },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.isLoading ? "Lade..." : "Mehr laden") +
                    "\n    "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isFullscreenOpen && _vm.activeLook
        ? _c("shop-the-look-fullscreen", {
            attrs: {
              look: _vm.activeLook,
              "selected-look-id": _vm.activeVariantId,
              "is-loading": _vm.isLoading,
              "is-prev-disabled": _vm.isFirstLookActive,
              "is-next-disabled": _vm.isLastLookActive,
            },
            on: {
              close: _vm.closeFullscreen,
              "request-next": _vm.showNextLook,
              "request-previous": _vm.showPreviousLook,
              "select-variant": _vm.setActiveVariantId,
              "select-tag": _vm.handleFullscreenTagSelect,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "stlFilterSheetEyebrow" }, [_vm._v("Filter")]),
      _vm._v(" "),
      _c("h2", [_vm._v("Looks filtern")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }